import ChangeDocumentTypeModal from './ChangeDocumentTypeModal';

export default ChangeDocumentTypeModal;
